import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createBlock(_component_loader_guard, {
    "has-loaded": _ctx.allowRender,
    size: _ctx.size
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["has-loaded", "size"]))
}